import { render } from "./AuthPhoneConfirm.vue?vue&type=template&id=dc954cea&scoped=true&ts=true"
import script from "./AuthPhoneConfirm.vue?vue&type=script&lang=ts"
export * from "./AuthPhoneConfirm.vue?vue&type=script&lang=ts"

import "./AuthPhoneConfirm.vue?vue&type=style&index=0&id=dc954cea&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1364277118/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc954cea"]])

export default __exports__